import { usePlethoreForm } from '@/contexts/FormContext'
import { App, Button, Form } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'

const DevAutoFill: FC = () => {
  const { message } = App.useApp()
  const { currentStep, steps } = usePlethoreForm()
  const form = Form.useFormInstance()

  if (
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ||
    currentStep === 0
  ) {
    return <></>
  }

  const handleAutofill = () => {
    // Generate dummy data for the current step only
    if (!steps || steps.length === 0) return

    const currentStepData = steps[currentStep]
    if (!currentStepData) return

    currentStepData.sections.forEach((section) => {
      section.items.forEach((field) => {
        if (field.type.name === 'photo') {
          return // Skip photo fields
        }
        // Generate dummy data based on field type
        let value: any
        switch (field.type.name) {
          case 'text':
          case 'textarea':
            value = `Test ${field.name}`
            break
          case 'email':
            value = 'test@example.com'
            break
          case 'phone':
            value = '+33612345678'
            break
          case 'number':
            value = 123
            break
          case 'date':
          case 'birthDate':
            value = dayjs('1990-01-01').toISOString()
            break
          case 'select':
          case 'radio':
            value =
              (field.max ?? 1) > 1
                ? [field.options?.[0]?.id]
                : field.options?.[0]?.id
            break
          case 'checkbox':
            value = field.options?.map((opt) => opt.id)
            break
          case 'switch':
          case 'segment':
            value = field.options?.[0]?.id
            break
          default:
            value = 'test'
        }
        form.setFieldValue([...currentStepData.pathPrefix, field.name], value)
      })
    })

    message.success('Current step autofilled with dummy data')
  }

  return (
    <Button
      type="dashed"
      onClick={handleAutofill}
      style={{ alignSelf: 'flex-start' }}
    >
      🔧 Autofill (Dev)
    </Button>
  )
}

export { DevAutoFill }
